// Mock data for IronVision clone

export const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Products', path: '/products' },
  { name: 'About', path: '/about' },
  { name: 'Careers', path: '/careers' },
];

export const businessInfo = [
  { label: 'UEI', value: 'RGB4EE4995T6' },
  { label: 'CAGE Code', value: '94VS2' },
  { label: 'CMMC', value: 'Level 2 Certified' },
  { label: 'Facility Clearance', value: 'Top Secret' },
  { label: 'NAICS Code', value: '541511, 541512, 541513, 541519, 541611, 541618, 541690, 541990, 611420' },
];

export const services = [
  { icon: 'ShieldCheck', title: 'Cybersecurity Consulting', description: 'Security assessments, vulnerability management, and strategic planning to protect organizational assets and meet federal cybersecurity requirements.' },
  { icon: 'FileCheck2', title: 'Compliance & GRC', description: 'Multi-framework compliance management with our IronVision GRC Platform, supporting SOC 2, ISO 27001, NIST 800-53, CMMC, HIPAA, and PCI-DSS.' },
  { icon: 'Radar', title: 'Threat Detection & Response', description: '24/7 monitoring, incident response, and threat intelligence to identify and respond to security threats before they impact operations.' },
  { icon: 'Network', title: 'Infrastructure Security', description: 'Secure architecture, network hardening, and cloud security to protect infrastructure against intrusion and cyber attack.' },
];

export const industries = [
  { icon: 'Landmark', title: 'Government', description: 'IronVision leads the national effort to understand, manage, and reduce risk to cyber and physical infrastructure. We connect with industry and government to resource, analyze, and help build cyber, communications, and physical security and resilience.' },
  { icon: 'Banknote', title: 'Finance', description: 'Financial services face constant threats from sophisticated attackers. We provide comprehensive security solutions to protect sensitive financial data, ensure regulatory compliance, and maintain customer trust.' },
  { icon: 'HeartPulse', title: 'Healthcare', description: 'Healthcare organizations handle highly sensitive patient data. We help protect health records, maintain HIPAA compliance, and ensure critical care systems remain operational and secure.' },
  { icon: 'GraduationCap', title: 'Higher Education', description: 'Educational institutions host vast amounts of sensitive data. We protect against malware, ransomware, and data breaches while securing research data and student information.' },
  { icon: 'Truck', title: 'Logistics', description: 'As logistics digitizes with e-commerce growth, security becomes critical. We design solutions to mitigate threats and protect supply chain operations from cyber attacks.' },
  { icon: 'Zap', title: 'Energy', description: 'Energy sector security is paramount for national safety. We help protect power grids and critical infrastructure from sophisticated cyber threats that could impact millions.' },
];

export const heroStats = [
  { value: '15+', label: 'Years Experience' },
  { value: '100+', label: 'Clients Protected' },
  { value: '24/7', label: 'Security Monitoring' },
  { value: '99.9%', label: 'Uptime SLA' },
];

export const frameworks = [
  { name: 'SOC 2', version: 'Type I & II', controls: '116 Controls', description: 'Service Organization Control reporting for trust services criteria' },
  { name: 'ISO 27001', version: '2022', controls: '93 Controls', description: 'Information security management systems standard' },
  { name: 'NIST 800-53', version: 'Rev. 5', controls: '1189 Controls', description: 'Security and privacy controls for information systems' },
  { name: 'CMMC', version: '2.0', controls: '171 Controls', description: 'Cybersecurity Maturity Model Certification for defense contractors' },
  { name: 'HIPAA', version: 'Security Rule', controls: '54 Controls', description: 'Health Insurance Portability and Accountability Act compliance' },
  { name: 'PCI-DSS', version: 'v4.0', controls: '264 Controls', description: 'Payment Card Industry Data Security Standard' },
];

export const productStats = [
  { value: '60%', label: 'Reduction in duplicate effort' },
  { value: '3x', label: 'Faster audit preparation' },
  { value: '100%', label: 'Control visibility' },
  { value: '24/7', label: 'Continuous monitoring' },
];

export const capabilities = [
  { icon: 'GitMerge', title: 'Pre-Built Crosswalk Mappings', description: 'Eliminate duplicate compliance effort with structured mappings between overlapping frameworks.' },
  { icon: 'History', title: 'Version-Controlled Relationships', description: 'Track framework version changes and maintain audit-ready documentation automatically.' },
  { icon: 'Eye', title: 'Unified Compliance Visibility', description: 'Single dashboard view across all your compliance frameworks and control implementations.' },
  { icon: 'Settings2', title: 'Customizable Crosswalk Logic', description: "Tailor mapping relationships to match your organization's specific compliance interpretations." },
];

export const platformFeatures = [
  { icon: 'GitMerge', title: 'Crosswalk Mapping Engine', description: 'Automatically map controls across frameworks with our pre-built, validated crosswalk library. Customize mappings to match your compliance interpretations.', bullets: ['Pre-built mappings', 'Custom logic support', 'Version tracking', 'Audit trail'] },
  { icon: 'LayoutDashboard', title: 'Unified Control Dashboard', description: 'Single-pane visibility into your compliance posture across all frameworks. Real-time status tracking and gap identification.', bullets: ['Real-time status', 'Gap analysis', 'Control coverage', 'Framework comparison'] },
  { icon: 'FolderLock', title: 'Evidence Management', description: 'Centralized evidence collection and mapping. One piece of evidence can satisfy multiple control requirements automatically.', bullets: ['Multi-framework evidence', 'Auto-linking', 'Version control', 'Expiration tracking'] },
  { icon: 'BarChart3', title: 'Compliance Analytics', description: 'Detailed reporting and analytics on your compliance health. Track progress, identify trends, and demonstrate readiness.', bullets: ['Executive dashboards', 'Trend analysis', 'Risk scoring', 'Custom reports'] },
];

export const targetIndustries = [
  { icon: 'ShieldCheck', title: 'Government Contractors', description: 'CMMC, FedRAMP, NIST compliance' },
  { icon: 'HeartPulse', title: 'Healthcare', description: 'HIPAA, HITRUST readiness' },
  { icon: 'Banknote', title: 'Financial Services', description: 'SOC 2, PCI-DSS, SOX compliance' },
  { icon: 'Zap', title: 'Energy & Infrastructure', description: 'NERC CIP, critical systems' },
  { icon: 'Building2', title: 'Regulated SMBs', description: 'Multi-framework efficiency' },
];

export const securityBadges = [
  'SOC 2 Type II Certified',
  'End-to-End Encryption',
  'Data Residency Options',
  '99.9% Uptime SLA',
];

export const values = [
  { icon: 'ShieldCheck', title: 'Security First', description: 'We build security into everything we do, not as an afterthought. Our platform is designed with zero-trust architecture from the ground up.' },
  { icon: 'Target', title: 'Mission Focused', description: "We're dedicated to helping regulated organizations achieve and maintain compliance efficiently, protecting critical infrastructure and data." },
  { icon: 'Sparkles', title: 'Innovation Driven', description: 'We continuously evolve our platform to address emerging compliance challenges and leverage new technologies for better outcomes.' },
  { icon: 'Users', title: 'Customer Success', description: 'Your compliance success is our success. We partner closely with customers to ensure they achieve their compliance objectives.' },
];

export const pastPerformance = [
  { title: 'DISA Big Data Platform (BDP) Contract', description: 'Initiated critical support for the Defense Information Systems Agency (DISA) on the Big Data Platform, delivering high-level expertise in cloud-based security analytics and infrastructure hardening.' },
  { title: 'DCSA CSSP Contract Integration', description: 'Expanded operational footprint by securing a role on the Defense Counterintelligence and Security Agency (DCSA) Cybersecurity Service Provider (CSSP) contract, focusing on proactive network defense and incident response.' },
];

export const cultureBullets = [
  'We ship fast and iterate based on customer feedback',
  'We value clear communication over meetings',
  'We trust each other to do great work',
  'We celebrate wins and learn from failures',
  "We're building something meaningful together",
];

export const cultureStats = [
  { value: 'Mission', label: 'Focused' },
  { value: 'Clearance', label: 'Friendly' },
  { value: '100%', label: 'Remote' },
  { value: 'Flexible', label: 'Schedule' },
];

export const benefits = [
  { icon: 'Heart', title: 'Health & Wellness', description: 'Comprehensive medical, dental, and vision coverage for you and your family.' },
  { icon: 'Home', title: 'Remote-First', description: 'Work from anywhere in the US with flexible hours and async-first culture.' },
  { icon: 'Medal', title: 'Military Leave', description: 'We support our troops and are able to support if you get the call.' },
  { icon: 'BookOpen', title: 'Learning Budget', description: '$2,000 annual budget for courses, conferences, and professional development.' },
  { icon: 'Users', title: 'Team Events', description: 'Quarterly team gatherings and annual company retreats to build connections.' },
  { icon: 'Baby', title: 'Maternity/Paternity Leave', description: 'Take the time you need during a special time in your life to focus on family.' },
];

export const openPositions = [
  { title: 'General Application', tag: 'General', description: "We're always looking for passionate individuals who are eager to make an impact.", location: 'Remote (US)', type: 'Full-time' },
];
